module.exports = __webpack_public_path__ + "static/img/9.4d0280f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/9.png
// module id = 27
// module chunks = 0